<template>
    <section class="testimonials text-center">
        <h1>What Our Customers Are Saying</h1>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit</p>
        <!-- Start Container -->
        <div class="container">
            <!-- Start Row -->
            <div class="row">
                <!-- Start Column -->
                <div
                    class="col-md-4"
                    v-for="(testimonials_client_info, index) in testimonials_clients_info"
                    :key="index"
                >
                    <!-- Start Client Box -->
                    <div class="client text-start">
                        <p class="client-opinion">{{ testimonials_client_info.client_opinion }}</p>
                        <!-- Start Client Info Box -->
                        <div class="client-info d-md-flex">
                            <img
                                src="../../assets/images/jeremy.png"
                                alt="Client Image"
                                class="client-image"
                            />
                            <!-- Start Client Info Summary Box -->
                            <div class="client-info-summary">
                                <h5 class="client-name fw-bold">
                                    {{ testimonials_client_info.client_name }}
                                </h5>
                                <span class="client-career">
                                    {{ testimonials_client_info.client_career }}
                                </span>
                            </div>
                            <!-- End Client Info Summary Box -->
                        </div>
                        <!-- End Client Info Box -->
                    </div>
                    <!-- End Client Box -->
                </div>
                <!-- End Column -->
            </div>
            <!-- End Row -->
        </div>
        <!-- End Container -->
    </section>
</template>

<style scoped lang="scss">

    .testimonials{
        padding: var(--main-padding);
        background-color: var(--second-background);

        > h1 {
            margin-bottom: 50px;
            position: relative;
            &::after{
                content: '';
                position: absolute;
                bottom: -25px;
                left: calc(50% - 50px);
                width: 100px;
                height: 3px;
                background-color: var(--main-color)
            }
        }

        > p{
            margin-bottom: 50px;
            @media(max-width: 767px){
                margin-bottom: 20px
            }
        }

        p{
            color: var(--second-color)
        }

        .client{
            .client-opinion{
                background-color: #FFF;
                padding: 15px;
                font-size: 15px;
                text-align: justify;
                margin-bottom: 30px;
                position: relative;
                &::after{
                    content: '';
                    position: absolute;
                    bottom: -30px;
                    left: 20px;
                    border-width: 15px;
                    border-style: solid;
                    border-color: #FFF transparent transparent transparent;
                    @media(max-width: 767px){
                        left: calc(50% - 7px)
                    }
                }
            }
            
            .client-info{
                background-color: #FFF;
                padding: 15px;
                box-shadow: 1px 1px 3px #F00, -1px -1px 3px #00F;
                border-radius: 10px;
                .client-image{
                    width: 80px;
                    height: 80px;
                    border-radius: 50%;
                    border: 2px solid var(--second-background);
                    padding: 5px
                }
                .client-info-summary{
                    padding-left: 20px;
                    .client-career{
                        color: var(--second-color)
                    }
                    @media(max-width: 767px){
                        padding-left: 0
                    }
                }
                @media(max-width: 767px){
                    text-align: center
                }
            }
            @media(max-width: 767px){
                padding-bottom: 40px
            }
            @media(min-width: 768px) and (max-width: 991px){
                padding-bottom: 30px
            }
        }
    }

</style>

<script>

import {testimonials_clients_info} from "../../assets/jsonData/index.json"

export default {

    name: "Testimonials",

    data: function () {

        return {

            testimonials_clients_info

        }

    }

}

</script>